var render = function render(){
  var _vm$value, _vm$value$resume, _vm$value$resume$pers, _vm$value2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._g(_vm._b({
    attrs: {
      "elevation": "0",
      "rounded": "",
      "color": "white"
    }
  }, 'v-card', Object.assign({}, _vm.$attrs, {
    class: Object.assign({}, _vm.$attrs.class || {})
  }), false), _vm.eventsHandler), [_c('div', {
    staticClass: "pa-16 pb-10"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_vm.selectable ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-simple-checkbox', _vm._g({
    attrs: {
      "value": _vm.isSelected,
      "color": "primary"
    }
  }, _vm.eventsHandler))], 1) : _vm._e(), _c('v-col', [_c('v-layout', {
    staticClass: "flex-row flex-lg-column flex-xl-row align-center align-lg-start align-xl-center"
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium grey-13--text mr-4"
  }, [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$resume = _vm$value.resume) === null || _vm$value$resume === void 0 ? void 0 : (_vm$value$resume$pers = _vm$value$resume.personalInformation) === null || _vm$value$resume$pers === void 0 ? void 0 : _vm$value$resume$pers.name) + " ")]), _c('p', {
    staticClass: "page-text--sm grey-9--text"
  }, [_vm._v("(" + _vm._s(_vm.gender) + ", " + _vm._s(_vm.age) + ")")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    staticClass: "v-avatar--small",
    attrs: {
      "color": "grey"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profileSrc
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.profileSrc,
      expression: "!profileSrc"
    }],
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1)], 1)], 1)], 1)], 1)], 1), _c('ul', {
    staticClass: "dot-texts"
  }, _vm._l(_vm.cardTextList, function (text) {
    return _c('li', {
      key: text,
      staticClass: "dot-text page-text--sm grey-6--text"
    }, [_vm._v("· " + _vm._s(text))]);
  }), 0)]), _c('v-divider'), _c('div', {
    staticClass: "px-8 py-2"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('application-view', _vm._b({
    ref: "application-view",
    on: {
      "input": function (value) {
        return _vm.$emit('input', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": "grey-9"
          }
        }, 'v-btn', Object.assign({}, attrs), false), on), [_c('v-icon', [_vm._v(" mdi-checkbox-multiple-blank-outline ")])], 1)];
      }
    }])
  }, 'application-view', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false))], 1), _c('v-col', {
    staticClass: "ml-n8"
  }, [_c('like-btn', {
    attrs: {
      "params": {
        _application: (_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2._id,
        type: _vm.USER_LIKE_TYPES.APPLICATION.value
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var active = _ref2.active,
          toggle = _ref2.toggle;
        return [_c('v-btn', {
          attrs: {
            "color": active ? 'yellow darken-1' : 'grey-9',
            "icon": "",
            "text": "",
            "small": ""
          },
          on: {
            "!click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return function () {
                return !_vm.selectable && toggle();
              }.apply(null, arguments);
            }
          }
        }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), false ? void 0 : _vm.withdrawn ? [_c('v-overlay', {
    staticClass: "text-h2 font-weight-bold",
    attrs: {
      "absolute": "",
      "color": "black",
      "opacity": "0.25"
    }
  }, [_vm._v(" 탈퇴회원 ")])] : _vm.isRevoked ? [_c('v-overlay', {
    staticClass: "text-h2 font-weight-bold",
    attrs: {
      "absolute": "",
      "color": "black",
      "opacity": "0.25"
    }
  }, [_vm._v(" 지원취소 ")])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }